import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeteringServiceProvider } from "../../../../utils/backend-types";
import { MspCategory } from "../../../../utils/enums";
import { getMspCategoryLabel } from "../../utils/getMspCategoryLabel";
import { METERING_SERVICE_PROVIDER_FIELD_LABELS } from "../MeteringServiceProviderTable";

const categoryChoices = Object.values(MspCategory).map((value) => ({
  label: getMspCategoryLabel(value),
  value: value
}));

function getCategoryColumn(): MRT_ColumnDef<MeteringServiceProvider> {
  return {
    accessorKey: "category",
    header: METERING_SERVICE_PROVIDER_FIELD_LABELS["category"],
    size: 240,
    editVariant: "select",
    mantineEditSelectProps: { data: categoryChoices },
    Cell: ({ renderedCellValue }) =>
      getMspCategoryLabel(renderedCellValue as MspCategory)
  };
}

export { getCategoryColumn };
